<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">网格信息维护&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>事项公示管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%;width: 100%;">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="公示类型">
                <el-select
                  filterable
                  placeholder="请选择公示类型"
                  clearable
                  v-model="form.noticeType"
                >
                  <el-option
                    v-for="item in pointTypeOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="标题">
                <el-input
                  v-model="form.noticeTitle"
                  clearable
                  placeholder="请输入标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="来源">
                <el-select
                  filterable
                  placeholder="请选择来源"
                  clearable
                  v-model="form.noticeSource"
                >
                  <el-option
                    v-for="item in noticeSourceList"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发布状态">
                <el-select
                  filterable
                  placeholder="请选择发布状态"
                  clearable
                  v-model="form.flagStatus"
                >
                  <el-option
                    v-for="item in flagStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发布时间">
                <el-date-picker
                  v-model="date"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn"></div>
          <div class="right-btn">
            <el-button @click="addDialogFun({})" class="search el-icon-plus"
              >新增</el-button
            >
          </div>
        </div>
        <common-table
          :select="false"
          :page="page"
          :dataList="dataList"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
          <template v-slot:flagStatus="{ scope }">
            <div v-for="(item,index) in flagStatusList" :key="index">
              <div v-if="scope.row.flagStatus == item.value">{{item.label}}</div>
            </div>
          </template>

          <template v-slot:operation="{ scope }">
            <el-button
              @click="addDialogFun(scope.row)"
              style="color: #0090FF;font-size: 16px;"
              type="text"
              >编辑</el-button
            >
            <el-popconfirm
              title="确定撤销此公示吗？"
              @confirm="revoke(scope.row.id)"
              v-if="scope.row.flagStatus == 2"
            >
              <el-button
                style="color: #EB3538;font-size: 16px;"
                type="text"
                slot="reference"
              >撤销发布</el-button>
            </el-popconfirm>
            <el-popconfirm
              title="确定发布此公示吗？"
              @confirm="release(scope.row.id)"
              v-if="scope.row.flagStatus == 1"
            >
              <el-button
                style="color: #0090FF;font-size: 16px;"
                type="text"
                slot="reference"
              >发布</el-button>
            </el-popconfirm>
            <el-popconfirm
              title="确定删除此公示吗？"
              @confirm="delNoticeFun(scope.row.id)"
            >
              <el-button
                style="color: #EB3538;font-size: 16px;"
                type="text"
                slot="reference"
              >删除</el-button>
            </el-popconfirm>
          </template>
        </common-table>
      </div>
    </div>
    <addDialog
      v-if="dialogVisible"
      @refreshList="sysNoticePage"
      :dialogVisible.sync="dialogVisible"
      :noticeSourceList="noticeSourceList"
      :pointTypeOptions="pointTypeOptions"
      :curItem="curItem"
    >
    </addDialog>
  </div>
</template>
<script>
import { delNotice,sysNoticePage } from "@/api/task.js";
import addDialog from "./components/addDialog.vue";
import commonTable from "@/components/table/index.vue";
import index from "./index";
import {backNotice, publicNotice} from "../../../api/task";
export default {
  components: {
    addDialog,
    commonTable
  },
  mixins: [index],
  data() {
    return {
      form: {
        "eqToDeptCode": "",
        "flagStatus": "",
        "noticeTitle": "",
        "noticeType": "",
        "publicTime": "",
        noticeSource: '',
      },
      date:[],
      noticeSourceList:['公众号','本系统创建'],
      flagStatusList:[
        {label: '已删除',value: 0},
        {label: '未发布',value: 1},
        {label: '已发布',value: 2},
      ],
      isFrontDisplayedOptions: [
        {
          label: "展示",
          value: 0
        },
        {
          label: "不展示",
          value: 1
        }
      ],
      dialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "noticeType",
            label: "公示类型"
          },
          {
            prop: "noticeTitle",
            label: "标题"
          },
          {
            prop: "toDeptName",
            label: "所属部门"
          },
          {
            prop: "noticeSource",
            label: "来源"
          },
          {
            prop: "createUsername",
            label: "创建人员"
          },
          {
            prop: "publicTime",
            label: "发布时间"
          },
          {
            slot: "flagStatus",
            label: "发布状态"
          },
          {
            slot: "operation",
            label: "操作"
          }
        ]
      },
      curItem: {}
    };
  },
  mounted() {
    this.sysNoticePage();
  },
  methods: {
    addDialogFun(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.sysNoticePage();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.sysNoticePage();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.sysNoticePage();
    },
    onReset() {
    for(let key in this.form) {
      this.form[key] = ''
    }
    this.date = []
      this.page.page = 1;
      this.page.size = 10;
      this.sysNoticePage();
    },
    // 撤销
    async revoke(id){
      const res = await backNotice({id:id})
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "撤销成功"
        });
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 发布
    async release(id){
      const res = await publicNotice({id:id})
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "发布成功"
        });
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 删除
    async delNoticeFun(id) {
      console.log('777')
      let params = {
        id: id
      };
      const res = await delNotice(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 分页查询
    async sysNoticePage() {
      if (this.date && this.date.length) {
        this.form.publicTimeStart = this.date[0]
        this.form.publicTimeEnd = this.date[1]
      } else {
        this.form.publicTimeStart = ''
        this.form.publicTimeEnd = ''
      }
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size
      };
      const res = await sysNoticePage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records ? res.data.data.records : [];
        this.page.total = res.data.data.total;
      }
    }
  },
  computed: {
    getPointTypeName() {
      return function(id) {
        let name = "";
        this.pointTypeOptions.forEach(item => {
          if (item.id == id) {
            name = item.typeName;
          }
        });
        return name;
      };
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/streetInfo/publicNotice/index.vue